import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/result',
    name: 'result',
    component: () => import(/* webpackChunkName: "about" */ '../views/result.vue')
  },
  {
    path: '/mulazim',
    name: 'mulazim',
    component: () => import(/* webpackChunkName: "about" */ '../views/mulazim.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/login.vue')
  },
  {
    path: '/error',
    name: 'error',
    component: () => import(/* webpackChunkName: "about" */ '../views/error.vue')
  },
  {
    path: '/t',
    name: 'time',
    component: () => import(/* webpackChunkName: "about" */ '../views/time.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
